import {Component, inject, signal} from '@angular/core';
import {Router} from '@angular/router';
import {ArchitecturalPrinciple} from '@frontend/directus';
import {APP_ROUTES} from '../../../app.routes';
import {HrToolService} from '../hr-tool.service';
import {HrToolTile} from '../hr-tool.types';
import {NoDataComponent} from '../../../shared/components/no-data/no-data.component';

@Component({
  selector: 'app-hr-tool-overview',
  imports: [NoDataComponent],
  templateUrl: './hr-tool-overview.component.html',
})
export class HrToolOverviewComponent {
  private readonly hrToolsService = inject(HrToolService);
  private readonly router = inject(Router);

  protected readonly toolTiles = this.hrToolsService.toolTiles;
  private readonly brokenLogos = signal<Set<string>>(new Set());

  protected applicationTypeIcon(type: ArchitecturalPrinciple): string {
    return this.hrToolsService.applicationTypeIcon(type);
  }

  protected applicationTypeLabel(type: ArchitecturalPrinciple): string {
    return this.hrToolsService.applicationTypeLabel(type);
  }

  protected showLogo(tile: HrToolTile): boolean {
    return !!tile.logoUrl && !this.brokenLogos().has(tile.id);
  }

  protected onLogoError(tile: HrToolTile): void {
    this.brokenLogos.update((broken) => new Set(broken).add(tile.id));
  }

  protected openTool(tile: HrToolTile): void {
    void this.router.navigate([APP_ROUTES.HR_TOOLS, tile.id]);
  }
}
